export default __webpack_public_path__ + "static/media/07.11.24 Minutes of the Special Meeting of the BOD.176db917.pdf";